import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-tag',
  templateUrl: 'tag.component.html',
  styleUrls: ['./tag.component.less', '../common.less'],
})

export class CustomTagComponent implements OnInit {
  @Input() isValidated: boolean = false;
  @Input() text: string = 'Validé';
  @Input() backgroundColor: string = '#DEFEE6';
  @Input() textColor: string = '#32A24C';
  @Input() icon: string = '';
  @Input() fitContent: boolean = false;


  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
